// extracted by mini-css-extract-plugin
module.exports = {"innerAccordion":"QuestionsForm-styles-module--innerAccordion--1Mc0Y"};